import localDateChooser from './LocalDateChooser';
import 'gw-portals-viewmodel-angular';
import 'edge/platform/widgets/datetimepicker/module';
import 'edge/platform/time/module';

export default angular.module('edge.platform.widgets.ui.time', ['edge.platform.widgets.ui.bootstrap.datetimepicker', 'edge.platform.time']).directive('gwPlLocalDateChooser', localDateChooser);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/time/module.js
// module id = 1174
// module chunks = 0